<template>
	<section class="section login">
		<div class="columns is-centered">
			<div class="column is-6 is-4-fullhd">
				<h4 class="title is-left">{{ $t('Password reset') }}</h4>
				
				<b-field :type="{ 'is-danger': validation['password']}"
					:message="validation['password'] && $t('Password should be atleast 8 characters')" 
            		:label="$t('New Password')" 
					label-for="password">
					<b-input
						required
						type="password"
						v-model="user.password"
						password-reveal
						id="password"
					></b-input>
				</b-field>
				<b-field :type="{ 'is-danger': validation['confirmPassword']}"
            		:message="validation['confirmPassword'] && $t('Passwords should match')" 
					:label="$t('Confirm Password')" label-for="confirmPassword">
					<b-input
						required
						type="password"
						v-model="user.confirmPassword"
						password-reveal
						id="confirmPassword"
					></b-input>
				</b-field>
				
				
				<b-button type="is-primary" @click="resetPassword">{{ $t('RESET MY PASSWORD') }}</b-button>
				<hr>
				<div >
					
					<b-button
						v-if="this.$i18n.locale == 'hu'"
						type="is-primary"
						outlined
						@click="goBack"
						>{{ $t('Go Back') }}</b-button
					>
					<b-button
						v-else
						type="is-primary"
						outlined
						@click="goBack"
						>{{ $t('Go Back') }}</b-button
					>
				</div>
			</div>
		</div>
	</section>
</template>
<script>
export default {
	name: 'ForgetPass',
	components: {},
	metaInfo () {
		return {
			title: this.$t("Password reset"),
			meta: [
				{ name: 'robots', content: 'noindex' },
			]
		}
	},
	data() {
		return {
			user: {
				password: '',
				confirmPassword:'',
			},
			validation: {},
		}
	},
	methods: {
		goBack: function () {
			var _this = this
			_this.$router.back();
		},
		resetPassword: function() {
			this.validation= {};
			//reset password form validation


			if (!this.user.password || this.user.password.length < 8) {
				this.validation["password"] = "Error";
			}

			if (!this.user.confirmPassword || this.user.confirmPassword !== this.user.password) {
				this.validation["confirmPassword"] = "Error";
				
			}
			if(Object.keys(this.validation).length !== 0){
				return;
			}

			//reset password api call

			var _this = this
			if(this.$route.query.resetToken && this.$route.query.resetToken===''){
				_this.$buefy.snackbar.open({
					message: _this.$t('Invalid password reset link'),
					type: 'is-danger',
					position: 'is-top',
					duration: 5000,
					queue: false,
				})
				return;
			}
			this.$http
				.post('/users/resetPassword', {...this.user, token: this.$route.query.resetToken})
				.then((response) => {
					console.log("user/resetPassword:", response, _this.$socket.id);
					_this.$buefy.snackbar.open({
						message: _this.$t('Password changed successfuly'),
						position: 'is-top',
						queue: false,
					})
					console.log('ROUTE', _this.$route)
					_this.$router.replace({ name: 'Login' })
				})
				.catch((error) => {
					console.log(JSON.stringify(error));
					_this.$buefy.snackbar.open({
						message: _this.$t('Failed password reset'),
						type: 'is-danger',
						position: 'is-top',
						duration: 5000,
						queue: false,
					})
				})
			
			
		}
	},
}
</script>
